export const stringWithOnlyNumbers = (string: string): boolean => {
    let valid = true
    for (let i = 0; i < string.length; i++) {
        if (isNaN(parseInt(string[i]))) {
            valid = false
        }
    }
    return valid
}